import Vue from 'vue';
import Component from 'vue-class-component';
import { G2S } from 'core/g2s';
import * as api from 'core/api';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class FlightTermsComponent extends Vue {
    searchId: string;
    flightId: string;
    publicReservationId: string;

    fareDetails: api.FareDetailsResponse | null = null;

    show(searchId: string, flightId: string, publicReservationId?: string) {
        if (searchId != this.searchId
            || flightId != this.flightId
            || (publicReservationId && publicReservationId != this.publicReservationId)) {
            this.fareDetails = null;
        }

        this.searchId = searchId;
        this.flightId = flightId;
        if (publicReservationId) {
            this.publicReservationId = publicReservationId;
        }

        (<any>this).$refs.dialog.isActive = true;

        this.loadFlightTerms();
    }

    loadFlightTerms() {
        const request: api.FareDetailsRequest = {
            searchId: this.searchId,
            flightId: this.flightId,
            publicReservationId: this.publicReservationId
        };

        new api.FlightService().fareDetails(request).then(
            (result: api.FareDetailsResponse) => {
                this.fareDetails = result;
            },
            (error) => {
                this.fareDetails = { isSuccess: false };

                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
    }

    onFlightTermsRetry() {
        this.fareDetails = null;

        this.loadFlightTerms();
    }
}
